<template>
<div class="header">
  <div class="top" style="display:none;">
    <router-link tag="a" to="/"><div class="top-left"></div></router-link>
    <div class="top-right">   
      <div style="margin-top:8px;"><router-link tag="a" to="/"><img src="./../assets/image/z_back.png" alt=""></router-link></div>   
      <div v-if="!token"><router-link tag="a" to="/login"><img src="./../assets/image/h_login.png" alt=""></router-link></div>   
      <div v-if="token"><router-link tag="a" to="/login"><img src="./../assets/image/h_back.png" alt=""></router-link></div>   
      <!-- <el-button type="primary" icon="el-icon-search"><router-link tag="a" to="/">返回首页</router-link></el-button>
      <el-button type="primary" icon="el-icon-search" v-if="!token"><router-link tag="a" to="/login" >会员登录</router-link></el-button>
      <el-button type="primary" icon="el-icon-search" v-if="!token" @click="logout"><router-link tag="a" to="/login" >会员退出</router-link></el-button> -->
    </div>
    <div class="top-right2">
      <div style="margin-top:68px" v-if="token">欢迎您,{{username}}</div>
    </div>
  </div>
          <!-- <ul class="nav">
            <router-link tag="li" to="/" exact>首页</router-link>
            <router-link tag="li" to="/articlelist" exact>动态要闻</router-link>
            <router-link tag="li" to="/selfassessment" exact>企业自评</router-link>
            <router-link tag="li" to="/industrymap" exact>产业地图</router-link>
            <router-link tag="li" to="/login" exact>会员中心</router-link>
            <router-link tag="li" to="/aboutus" exact>关于我们</router-link>
          </ul> -->
          <div style="float:right;margin-right:50px;padding-top:17px;">
            <!-- <div style="margin-top:8px;"><router-link tag="a" to="/"><img src="./../assets/image/z_back.png" alt=""></router-link></div>    -->
            <!-- <div v-if="!token"><router-link tag="a" to="/login"><img src="./../assets/image/h_login.png" alt=""></router-link></div>   
            <div v-if="token"><router-link tag="a" to="/login"><img src="./../assets/image/h_back.png" alt=""></router-link></div>    -->
          </div>
          <div style="width:1200px;margin:0 auto;border:1px solid transparent;position:relative;">
            <img src="../assets/image/logo.png" alt="" style="float:left;margin-top:34px;">
            <button type="button" class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen">
              <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
            </button>
            <div style="position:absolute;right:120px;top:14px;" v-if="!token"><router-link tag="a" to="/register" style="text-decoration: none;font-size:18px;color:#777;color:#0099E2;font-weight:bold;border-radius:5px;display:inline-block;height:30px;line-height:30px;font-size:14px;background:#E71F10;color:#fff;width:80px;">加入我们</router-link></div>   
            <div style="position:absolute;right:20px;top:20px;" v-if="!token"><router-link tag="a" to="/login" style="text-decoration: none;font-size:18px;color:#777;color:#0099E2;font-weight:bold;">会员登录</router-link></div>   
            <div style="position:absolute;right:20px;top:20px;" v-if="token" @click="logout"><router-link tag="a" to="/login" style="text-decoration: none;font-size:18px;color:#777;color:#0099E2;font-weight:bold;">会员退出</router-link></div>   
            <ul class="nav" style="margin-top:40px;" :class="{ open: mobileMenuOpen }">
              <router-link tag="li" to="/" exact style="margin-left:200px;">
              <!-- <img style="vertical-align:millde;" src="./../assets/image/tab_home.png" alt=""> -->
              首页</router-link>
              <router-link tag="li" to="/articlelist" exact>
              <!-- <img src="./../assets/image/tab_yaowen.png" alt=""> -->
              动态要闻</router-link>
              <router-link tag="li" to="/selfassessment" exact>
              <!-- <img src="./../assets/image/tab_ziping.png" alt=""> -->
              企业自评</router-link>
              <router-link tag="li" to="/industrymap" exact>
              <!-- <img src="./../assets/image/tab_gis.png" alt=""> -->
              产业地图</router-link>
              <router-link tag="li" to="/huiyuanCenter" exact>
              <!-- <img src="./../assets/image/tab_huiyuan.png" alt=""> -->
              会员中心</router-link>
              <router-link tag="li" to="/aboutus" exact>
              <!-- <img src="./../assets/image/tab_our.png" alt=""> -->
              关于我们</router-link>
              <router-link tag="li" to="/login" class="mobile-only">会员登录</router-link>
              <router-link tag="li" to="/register" class="mobile-only">加入我们</router-link>
            </ul>
          </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import jwt_decode from "jwt-decode";
export default {
  data(){
    return{
      username:"",
      mobileMenuOpen:false
    }
  },
  mounted:function(){
    if(this.token){
      this.username = jwt_decode(this.token).sub;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("FedLogOut");
    }
  },
  watch: {
    $route() {
      this.mobileMenuOpen = false;
    }
  },
  computed: {
    ...mapGetters(["name", "authorities", "token"])
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 100px;
  width: 1200px;
  margin: 0 auto;
  .top-left {
    // width: 316px;
    width: 430px;
    height: 100px;
    float: left;
    background: url(../assets/image/logo.png) no-repeat 0 20px;
  }
  .top-right {
    width: 147px;
    height: 100px;
    float: right;
    .el-button {
      margin: 5px 0 5px;
      color: red;
      border-radius: 0;
      border-color: #ebebeb;
      background-color: #ebebeb;
      a {
        color: #666666;
        text-decoration: none;
      }
    }
  }
  .top-right2 {
    //width: 147px;
    height: 100px;
    float: right;
 }
}
.nav {
  height: 50px;
  width: 1200px;
  margin: 0 auto;
  // background-color: #0099E2;
  li {
    height: 50px;
    line-height: 50px;
    color: #fff;
    float: left;
    /* padding: 0 20px;
    color: #777;
    font-size: 16px; */
    padding: 0 0 0 30px;
    color: #000;
    font-size: 18px;
    cursor: pointer;
    img {
      margin-right:5px;
      position: relative;
      top: 2px;
    }
  }
  li.active {
    // background-color: #34920b;
    color: #0099E2;
    font-weight: bold;
  }
  li:hover {
    // background-color: #58a537;
    color: #0099E2;
    font-weight: bold;
  }
}
.header {
  // display: none;
  position: fixed;
  left:0;
  top:0;
  width: 100vw;
  z-index: 99;
  // border:1px solid red;
  background: rgba(255,255,255,0.75);
}

.mobile-menu-btn {
  display: none;
}

.mobile-only {
  display: none !important;
}

@media (max-width: 1199.98px) {
  .nav {
    width: 100% !important;
  }
}

@media (max-width: 767.98px) {
  .mobile-menu-btn {
    display: block;
    position: absolute;
    right: 10px;
    top: 18px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    background: #ffffff;
    color: #0099e2;
    font-size: 18px;
    cursor: pointer;
    z-index: 101;
  }

  .header [style*="right: 120px"],
  .header [style*="right: 20px"] {
    display: none !important;
  }

  .nav {
    display: none;
    position: absolute;
    top: 64px;
    left: 0;
    width: 100% !important;
    margin: 0 !important;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 100;
  }

  .nav.open {
    display: block;
  }

  .nav li {
    float: none !important;
    display: block !important;
    width: 100%;
    text-align: center;
    padding: 14px 0 !important;
    border-bottom: 1px solid #f2f2f2;
  }

  .nav li.mobile-only {
    display: block !important;
  }

  .header img {
    width: 110px !important;
    height: auto !important;
    margin-top: 15px !important;
  }
}
</style>
